import React, { useEffect } from "react";
import MainPage from "./screens/MainPage";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import MainStore from "./screens/MainStore";
import MainSubscription from "./screens/MainSubscription";
import MainEvent from "./screens/MainEvents";
import MainAloo from "./screens/MainAloo";
import MainLab from "./screens/MainLabs";
import MainRoute from "./screens/MainRoute";
import MainCourse from "./screens/MainCourse";
import MainLibrary from "./screens/MainLibrary";
import MainInfo from "./screens/MainInfo";
import Countdown from "./screens/Countdown";
import { initGA, trackPageView } from "./analytics";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
}

const App = () => {
  useEffect(() => {
    initGA();
  }, []);
  return (
    <Router>
      <AnalyticsTracker />
      <Routes>
        {/* <Route path="/" element={<Countdown />} /> */}
        <Route path="/" element={<MainPage />} />
        <Route path="infos" element={<MainInfo />} />
        <Route path="store" element={<MainStore />} />
        <Route path="subscription" element={<MainSubscription />} />
        <Route path="event" element={<MainEvent />} />
        <Route path="library" element={<MainLibrary />} />
        <Route path="lab" element={<MainLab />} />
        <Route path="aloo" element={<MainAloo />} />
        <Route path="route" element={<MainRoute />} />
        <Route path="course" element={<MainCourse />} />
      </Routes>
    </Router>
  );
};

export default App;
